/**
 * Module dependencies.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Bell } from 'lucide-react';
import { Title } from 'app/components/atoms/title/title';

/**
 * Export `SettingsNotifications` component.
 */

export function SettingsNotifications(): JSX.Element {
  const [translate] = useTranslation();

  return (
    <>
      <Title>{translate('settings.notifications.title')}</Title>

      <div
        className={
          'flex min-h-[280px] flex-col items-center justify-center rounded-lg border border-dashed border-border bg-muted/30 px-6 py-16 text-center'
        }
      >
        <div className={'grid h-12 w-12 place-items-center rounded-full bg-muted text-muted-foreground'}>
          <Bell className={'h-6 w-6'} />
        </div>

        <h3 className={'mt-4 text-sm font-semibold text-foreground'}>
          {translate('settings.notifications.emptyTitle')}
        </h3>

        <p className={'mt-1 max-w-[360px] text-sm text-muted-foreground'}>
          {translate('settings.notifications.emptyDescription')}
        </p>
      </div>
    </>
  );
}
